export const GET_VALUES_TAGS_COMPANY = 'GET_VALUES_TAGS_COMPANY';
export const GET_VALUES_TAGS_EMPLOYEE = 'GET_VALUES_TAGS_EMPLOYEE';
export const CHANGE_VALUE_TAG = 'CHANGE_VALUE_TAG';
export const CHANGE_TAG = 'CHANGE_TAG';
export const CLEAN_VALUES_TAG_EMPLOYEE = 'CLEAN_VALUES_TAG_EMPLOYEE';
